var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"NEXD"}}),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"support-blog"}},[_c('a',{staticClass:"link",attrs:{"href":"https://support.nexd.com/","target":"_blank"}},[_vm._v("Support")]),_vm._v("  |  "),_c('a',{staticClass:"link",attrs:{"href":"https://www.nexd.com/blog","target":"_blank"}},[_vm._v("Blog")])])
}]

export { render, staticRenderFns }